// import React from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface InvoiceBatchExportSectionProps {
  exportableCount: number
  onBatchExport: () => void
  isExporting?: boolean
}

export function InvoiceBatchExportSection({
  exportableCount,
  onBatchExport,
  isExporting = false
}: InvoiceBatchExportSectionProps) {
  return (
    <Card className="items-start justify-end gap-6 self-stretch border border-solid border-neutral-200 shadow-box-shadow-shadow-sm flex px-0 py-6 relative flex-1 grow bg-white rounded-xl min-h-[280px]">
      <CardContent className="flex flex-col items-start gap-6 px-6 py-0 relative flex-1 self-stretch grow">
        <div className="flex flex-col w-[304px] items-start gap-1.5 relative flex-1 grow">
          <div className="flex items-center justify-between relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative flex items-center justify-center w-fit  font-text-base-semi-bold font-[number:var(--text-base-semi-bold-font-weight)] text-neutral-950 text-[length:var(--text-base-semi-bold-font-size)] tracking-[var(--text-base-semi-bold-letter-spacing)] leading-[var(--text-base-semi-bold-line-height)] whitespace-nowrap [font-style:var(--text-base-semi-bold-font-style)]">
              Batch Export
            </div>
            {exportableCount > 0 && (
              <div className="inline-flex items-center gap-2 relative flex-[0_0_auto]">
                <div className="relative w-2 h-2 bg-red-600 rounded" />
                <div className="relative flex items-center justify-center w-fit  font-text-xs-regular font-[number:var(--text-xs-regular-font-weight)] text-red-600 text-[length:var(--text-xs-regular-font-size)] tracking-[var(--text-xs-regular-letter-spacing)] leading-[var(--text-xs-regular-line-height)] whitespace-nowrap [font-style:var(--text-xs-regular-font-style)]">
                Ready
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col items-start gap-1.5 relative self-stretch w-full flex-[0_0_auto]">
            <div className="flex items-center justify-center gap-2.5 relative self-stretch w-full flex-[0_0_auto]">
              <div className="relative flex items-center justify-center flex-1  font-text-sm-regular font-[number:var(--text-sm-regular-font-weight)] text-neutral-500 text-[length:var(--text-sm-regular-font-size)] tracking-[var(--text-sm-regular-letter-spacing)] leading-[var(--text-sm-regular-line-height)] [font-style:var(--text-sm-regular-font-style)]">
                Export selected Reviewed invoices into one .zip file{exportableCount > 0 && ` (${exportableCount})`}
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-[304px] items-end gap-2 relative flex-[0_0_auto]">
          <Button
            onClick={onBatchExport}
            disabled={exportableCount === 0 || isExporting}
            className="h-9 px-4 py-2 bg-[#0000ff] text-white rounded-lg shadow-box-shadow-shadow-xs disabled:opacity-50 hover:bg-[#3333ff]"
          >
            {isExporting ? (
              <>
                <div className="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin mr-2" />
                <div className="relative w-fit  font-text-sm-medium font-[number:var(--text-sm-medium-font-weight)] text-neutral-50 text-[length:var(--text-sm-medium-font-size)] tracking-[var(--text-sm-medium-letter-spacing)] leading-[var(--text-sm-medium-line-height)] whitespace-nowrap [font-style:var(--text-sm-medium-font-style)]">
                  Exporting...
                </div>
              </>
            ) : (
              <div className="relative w-fit  font-text-sm-medium font-[number:var(--text-sm-medium-font-weight)] text-neutral-50 text-[length:var(--text-sm-medium-font-size)] tracking-[var(--text-sm-medium-letter-spacing)] leading-[var(--text-sm-medium-line-height)] whitespace-nowrap [font-style:var(--text-sm-medium-font-style)]">
                Export to XML{exportableCount > 0 && ` (${exportableCount})`}
              </div>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
